import { Controller } from 'stimulus';

require('@eastdesire/jscolor');

export default class extends Controller {
  connect() {
    if (!window.jscolor) return;

    this.element.dataset.jscolor = '{hash: true, required: false}';
    window.jscolor.install();
  }
}
